

// Yura skazal chto used both in field 1 and field3

export enum FieldValueType {
    STRING      = 'string',
    BOOLEAN     = 'boolean',
    FLOAT       = 'float',
    JSON        = 'json',
}


// it was dict
// {
//     STRING:     'string',
//         BOOLEAN:    'boolean',
//     FLOAT:      'float',
//     JSON:       'json',
// }